import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";

// Header button that switches a dialog between its normal size and filling the
// whole window. The caller owns the state and resizes its own dialog.
export default function FullscreenToggle({ fullscreen, onToggle }) {
  const label = fullscreen ? "Exit full screen" : "Full screen";
  return (
    <Tooltip title={label}>
      <IconButton size="small" color="primary" aria-label={label} onClick={onToggle}>
        {fullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </IconButton>
    </Tooltip>
  );
}
